import { useCustomersCustomerShowQuery } from "@/services/backend/customers/api/customer-api";
import t from "../../../../lang/lang";
import { NullUUID, UUID } from "@bitory-gmbh/nidavellir";
import { useEffect } from "react";
import { toast } from "sonner";
import { parseRTKQueryErrorToSonner } from "@/shared/components/errors/parse-r-t-k-query-error";

export function CustomerName(props: { customerId: UUID | null | undefined }) {
  const { customerId } = props;

  const {
    data: customer,
    isLoading,
    error,
  } = useCustomersCustomerShowQuery(
    { id: customerId || NullUUID },
    { skip: !customerId || customerId === "" },
  );

  useEffect(() => {
    if (error) {
      toast(...parseRTKQueryErrorToSonner(error));
    }
  }, [error]);

  if (!customerId || customerId === "") {
    return t("- ohne Kunde -");
  }

  if (isLoading) {
    return (
      <span className="animate-pulse">
        <span className="block h-2 rounded-full bg-gray-200" />
      </span>
    );
  }

  if (error) {
    return <span>{t("- Fehler -")}</span>;
  }

  return <span>{customer?.name}</span>;
}
